import { Card } from '@/components/ui/card';
import { Tag } from '@/components/common/Tag';
import type { RawScrapeRowDto } from '@/types/dto';

const fmtNum = new Intl.NumberFormat();

function fmtTime(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function ScrapeLog({ rows }: { rows: RawScrapeRowDto[] }) {
  return (
    <Card>
      <h2 className="text-xl font-semibold mb-3">Recent Raw Scrapes (last 50)</h2>
      {rows.length === 0 ? (
        <p className="text-muted">No scrapes yet.</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-accent">
              <Th>When</Th><Th>Entity</Th><Th>Source</Th><Th right>Bytes</Th><Th>Result</Th>
            </tr>
          </thead>
          <tbody>
            {rows.map((s, idx) => (
              <tr key={`${s.scrapedAt}-${idx}`} className="border-b border-border">
                <td className="py-2 px-3 text-muted whitespace-nowrap">{fmtTime(s.scrapedAt)}</td>
                <td className="py-2 px-3">{s.entityName ?? '—'}</td>
                <td className="py-2 px-3 text-muted">{s.sourceType}</td>
                <td className="py-2 px-3 text-muted text-right tabular-nums">{fmtNum.format(s.bytes)}</td>
                <td className="py-2 px-3">
                  <Tag variant={s.isDead ? 'tier-3' : 'tier-1'}>{s.isDead ? 'DEAD' : 'OK'}</Tag>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}

function Th({ children, right }: { children: React.ReactNode; right?: boolean }) {
  return (
    <th className={`py-2 px-3 text-[0.75rem] uppercase tracking-widest text-muted font-(family-name:--font-ui) ${right ? 'text-right' : 'text-left'}`}>
      {children}
    </th>
  );
}
